import React, { Fragment, useRef, useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import WarningBox from "../../Commons/WarningBox";
import { t } from 'i18next';
import SuccessDialog from "../../Commons/SuccessDialog";
import { ADMIN_INIT_FORGOT_PASSWORD } from '../../../store/actions/auth';
import * as Types from '../../../constants/actionTypes'
import FooterSignInPopup from "./FooterSignInPopup";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
    Button,
} from 'reactstrap';
import MineError from "../../Commons/MineError";

export default function ForgotPasswordPopup(props) {
    const { id, portalId, clientId, onShowForgotUsername } = props
    const [error, setError] = useState('');
    const [showForgotUsernameLink, setShowForgotUsernameLink] = useState(false);
    const [username, setUsername] = useState('');
    const [success, setSuccess] = useState(false);
    const [show, setShow] = useState(true);

    const dispatch = useDispatch();

    const onChangeInput = (event) => {
        let { name, value } = event.target
        setUsername(value);
    }

    const onForgotPassword = async (event) => {
        setSuccess(false);
        let _err = '';
        if (!username) {
            _err = t(`MsgErrorUsername`)
        }
        setError(_err)
        if (_err) {
            return;
        }
        try {
            let result = await dispatch(ADMIN_INIT_FORGOT_PASSWORD({ portalId, username, clientId }));
            if (result.type == Types.FORGOT_PASSWORD_ERROR) {
                let translatedError = t(`MsgErrorUsernameNotFound`);
                setError(translatedError);
                setShowForgotUsernameLink(true);
            }
            else {
                setShow(false);
                setSuccess(true);
            }
        } catch (error) {
            _err = error.response && error.response.data && error.response.data.error && error.response.data.error.message ? error.response.data.error.message : error.message;
            setError(_err);
        }
    }

    const toggleModal = () => {
        setShow(!show)
        if (show && props.onHide) {
            props.onHide()
        }
    };

    return (
        <Fragment>
            <Modal id={id} isOpen={show} keyboard={true} centered>
                <ModalHeader toggle={toggleModal} className="text-left">{t('NavLinkForgotPassword')}</ModalHeader>
                <ModalBody>
                    <div className="row my-4 px-2" style={{ backgroundColor: '#f8f8f8', borderRadius: '0.5rem' }}>
                        <div className='col-12 text-center find-username-guide mt-4' >{t('TxtFindYourPassword')}</div>
                        <div className="col-12 d-flex align-items-center my-4">
                            <Input className="form-control me-2" type="text" id="forgotPasswordInput" placeholder={t('PlaceholderUsername')}
                                name="username" value={username} required onChange={onChangeInput} style={{ height: '2.625rem' }} />
                            <Button type="button" className="btn btn-default rad-1" color="default" onClick={(e) => onForgotPassword(e)}>{t('CommonCode.BtnFind')}</Button>
                        </div>
                    </div>
                    {(error) ? <MineError message={error}></MineError> : null}
                    { showForgotUsernameLink ?
                        <div style={{marginLeft: '26px'}}>
                            <a className="lnk-btn" href='javascript: void(0);' onClick={() => { 
                                if (onShowForgotUsername) {
                                    onShowForgotUsername();
                                }
                            }}>{t('NavLinkForgotUsername')}</a>
                        </div>
                    : null}
                    <br />
                </ModalBody>
                <ModalFooter>
                    <FooterSignInPopup></FooterSignInPopup>
                </ModalFooter>
            </Modal>
            {(success) ? (
                <SuccessDialog id={'dialog-forgot-password-success' + id} content={t('TxtForgotPasswordSuccess')} onHide={()=> (props.onHide && props.onHide())}></SuccessDialog>
            ) : null}
        </Fragment>
    );
}